export default __webpack_public_path__ + "static/media/pwa-pass-3.228d8d76.svg";